var _rect, _path, _rect2, _rect3, _g, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvertVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.7088,
    y: 6.33766,
    width: 30.7021,
    height: 26.2163,
    transform: "rotate(-5 4.7088 6.33766)",
    fill: "#8C8F9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 13.882L26.2651 17.6099L17.6232 22.9192L16.8325 13.882Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.7088,
    y: 6.33766,
    width: 30.7021,
    height: 26.2163,
    transform: "rotate(-5 4.7088 6.33766)",
    stroke: "white",
    strokeWidth: 1.9925
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4948,
    y: 22.8066,
    width: 30.7021,
    height: 26.2163,
    transform: "rotate(5 22.4948 22.8066)",
    fill: "#0096CC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_33117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6103 31.4991L39.1112 29.9981L44.3564 35.235L42.8471 36.736C42.415 36.4568 41.9003 36.334 41.3886 36.388C40.877 36.4421 40.3992 36.6696 40.0349 37.0329L39.4164 37.6514C38.6576 38.4184 38.5587 39.5895 39.1277 40.4636L37.6185 41.9646L35.631 39.9771L33.3218 42.278C32.9754 42.6244 30.5343 44.5129 30.1879 44.1666C29.8415 43.8202 31.7218 41.3708 32.0682 41.0244L34.3692 38.7235L32.3816 36.7277L33.8908 35.2268C34.7568 35.7958 35.9361 35.6968 36.6948 34.9299L37.3134 34.3113C38.0803 33.5526 38.1793 32.3733 37.6103 31.4991Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4948,
    y: 22.8066,
    width: 30.7021,
    height: 26.2163,
    transform: "rotate(5 22.4948 22.8066)",
    stroke: "white",
    strokeWidth: 1.9925
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_33117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4941,
    height: 16.4941,
    fill: "white",
    transform: "translate(29.0005 29.0084)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertVideos);
export default __webpack_public_path__ + "static/media/convert_videos.2fb4219224e01166fcba32ecd41a79c2.svg";
export { ForwardRef as ReactComponent };